import capacitorConfig from "../../capacitor.config";

export const isMobile = (window as any)?.env?.isMobile === "true";

export const appVersion = isMobile
  ? capacitorConfig.plugins?.CapacitorUpdater?.version
  : undefined;
